define('shoptheme/components/ui/maps',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware/components/Config",
	"datatables"
], function(
	$,
	Component,
	BEM,
	Config
) {
	return Component.create({

		$init: function() {
			this.block = BEM.block('map');
			var mapContainer = this.block.bemGetElements('map');

			var apiKey = Config.get('google.maps.api.key');
			var apiUrl = 'https://maps.googleapis.com/maps/api/js?v=3&key=' + apiKey + '&sensor=false';

			var location = mapContainer.data('location-coords');

			$.getScript(apiUrl, function(data, textStatus, jqxhr) {
				var map = new google.maps.Map(mapContainer.get(0), {
					center: location,
					zoom: 12
				});

				var marker = new google.maps.Marker({
					position: location,
					map: map
				});
			});
		}

	});
});
